if (!customElements.get('cart-drawer-recommendation-item')) {
  customElements.define(
    'cart-drawer-recommendation-item',
    class CartDrawerRecommendationItem extends HTMLElement {
      constructor() {
        super();

        this.select = this.querySelector('.cart-drawer-recommendation__variant-select');
        this.variantIdInput = this.querySelector('input[name="id"]');
        this.submitButton = this.querySelector('.cart-drawer-recommendation__add');
        this.priceRoot = this.querySelector('.cart-drawer-recommendation__price');
        this.regularPriceItem = this.priceRoot?.querySelector('.price__regular .price-item--regular');
        this.saleComparePriceItem = this.priceRoot?.querySelector('.price__sale .price-item--regular');
        this.salePriceItem = this.priceRoot?.querySelector('.price__sale .price-item--sale');

        if (this.select) {
          this.select.addEventListener('change', this.onVariantChange.bind(this));
        }
      }

      onVariantChange() {
        const selectedOption = this.select.options[this.select.selectedIndex];
        if (!selectedOption || !this.variantIdInput) return;

        this.variantIdInput.value = selectedOption.value;

        const available = selectedOption.dataset.available === 'true';
        if (this.submitButton) this.submitButton.disabled = !available;

        if (!this.priceRoot) return;

        const onSale = selectedOption.dataset.onSale === 'true';
        this.priceRoot.classList.toggle('price--on-sale', onSale);

        if (onSale) {
          if (this.saleComparePriceItem) this.saleComparePriceItem.innerHTML = selectedOption.dataset.compareAtPrice;
          if (this.salePriceItem) this.salePriceItem.innerHTML = selectedOption.dataset.price;
        } else if (this.regularPriceItem) {
          this.regularPriceItem.innerHTML = selectedOption.dataset.price;
        }
      }
    }
  );
}
